// @ts-nocheck

import React, { useCallback } from 'react';
import styled from 'styled-components';

import { SpecialFilterValues } from '../../constants/livebar';
import FiltersWrapper from '../FiltersWrapper';
import MatchFilterItem from '../MatchFilterItem';

const StyledFiltersWrapper = styled(FiltersWrapper)``;

const Wrap = styled.div`
  padding: 0.5em 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  & > *:not(:last-child) {
    padding-right: 0.5em;
  }
`;

type LiveBarProps = {
  items: Array<{ id: number; count: number; name: string; icon: unknown; selected: boolean }>;
  onClickItem: (sportId: number) => void;
  className?: string;
};

const LiveBar = ({ items, onClickItem = () => {}, className }: LiveBarProps) => {
  const onItemClicked = useCallback(
    (itemId: number) => {
      const item = items.find((el) => el.id === itemId);
      if (item) {
        onClickItem(item.id);
      }
    },
    [items, onClickItem],
  );

  return (
    <StyledFiltersWrapper vertical={false} className={className}>
      <Wrap>
        {items.map((item, i) => (
          <MatchFilterItem
            key={`livebar-item-${item.id}-${i}`}
            count={item.count}
            icon={item.icon}
            isSelected={item.selected}
            isWinaTV={item.id === SpecialFilterValues.WINAMAX_TV_FILTER}
            onClick={() => onItemClicked(item.id)}
          />
        ))}
      </Wrap>
    </StyledFiltersWrapper>
  );
};

export default LiveBar;
